import { Component, OnInit } from '@angular/core';
import { TabParagraphContainerComponent } from '@spartacus/storefront';
import { of } from 'rxjs';

@Component({
    selector: 'app-uig-tab-paragraph-container',
    templateUrl: './uig-tab-paragraph-container.component.html',
    styleUrls: ['./uig-tab-paragraph-container.component.scss'],
    standalone: false
})
export class UigTabParagraphContainerComponent extends TabParagraphContainerComponent implements OnInit {

  ngOnInit() {
    this.filterTabsOnUndefined(); //So that the first tab is always active no matter which tab it is
    super.ngOnInit();
  }


  private filterTabsOnUndefined() {
    this.components$.subscribe((components) => {
      this.components$ = of(components.filter((x) => x !== undefined));
      this.activeTabNum = 0;
    });
  }
}
